define('rebrush/components/blocks/raster-grid/tiles/video',[
    'jquery',
    'cartware/components/_base',
    'cartware/jquery/bem',
    'lodash',
    './helpers/image/center',
    'cartware/components/Dispatcher',
    'videojs',
    'videojs-vimeo',
    'videojs-youtube',
    'magnific-popup'
], function(
    $,
    Component,
    BEM,
    _,
    ImageCenterHelper,
    ComponentDispatcher,
    videojs
) {
    var BLOCK_NAME = 'raster-grid-item-video';

    function Tile(block) {
        this.block = BEM.block(block);
        this.embed = this.block.getElements('embed');
        this.bindEvents();
    }

    Tile.prototype = {
        bindEvents: function() {
            this.block.on('click', 'a', _.bind(function(e) {
                // var link = e.currentTarget;
                e.preventDefault();
                this.openVideo();
            }, this));
        },

        openVideo: function() {
            $.magnificPopup.open({
                mainClass: 'mfp-full',
                fixedContentPos: true,
                items: {
                    src: this.embed.html(),
                    type: 'inline'
                }
            });

            var video = $.magnificPopup.instance.container.find('video');
            var setup = video.data('custom-setup');

            $.magnificPopup.instance.container.find('.' + BEM.buildElementClassname('raster-grid-item-video-popup', 'close')).on('click', function() {
                video.remove();
                $.magnificPopup.instance.container.html('');
                $.magnificPopup.instance.close();
            });

            video.data('custom-setup', setup);
            video.addClass('vjs-16-9');

            videojs(video.get(0), video.data('custom-setup'), function() {
                var player = this;
                if (video[0].hasAttribute('muted')) {
                    player.muted(true);
                }
                player.videoAspectRatio = video.data('aspect-ratio');
            });
        }
    };

    return Component.create({
        blocks: null,
        imageCenterHelpers: null,

        constructor: function() {
            this.imageCenterHelpers = [];
            this.tiles = [];
        },

        $init: function() {
            var self = this;

            this.blocks = BEM.block(BLOCK_NAME);
            this.blocks.each(function() {
                self.imageCenterHelpers.push(new ImageCenterHelper(this));
                self.tiles.push(new Tile(this));
            });

            this.hub.on('ui.component.rendering.after', function() {
                _.forEach(self.imageCenterHelpers, function(helper) {
                    helper.layout();
                });
            });
        }
    });
});
